<template>
  <div>
    <v-dialog v-model="show" persistent max-width="800px">
      <v-card class="dialog">
        <v-toolbar class="grey lighten-3">
          <span class="headline primary--text"> Disclaimer </span>
          <v-spacer />
          <v-btn icon @click="closeDialog()">
            <v-icon color="primary"> mdi-close </v-icon>
          </v-btn>
        </v-toolbar>
        <v-container style="max-height: 50vh; overflow-y: auto">
          <v-row>
            <v-col>
              <p class="font-weight-light">
                The Kentucky Division of Forestry makes no warranties or
                guarantees, either expressed or implied, as to the completeness,
                accuracy, or correctness of the data portrayed in this product
                nor accepts any liability arising from any incorrect,
                incomplete, or misleading information contained therein. All
                information, data, and databases are provided “as is” with no
                warranty, expressed or implied, including, but not limited to
                fitness for a particular purpose.
              </p>
              <p class="font-weight-light">
                Users should also note that property boundaries included in any
                product do not represent an on-the-ground survey suitable for
                legal, engineering, or surveying purposes. They represent only
                approximate relative locations.
              </p>
              <p class="font-weight-light">
                By accessing this website and/or data contained within the
                databases, you hereby release the Kentucky Division of Forestry
                and its employees, agents, contractors, and suppliers from any
                and all responsibility and liability associated with its use. In
                no event shall the Kentucky Division of Forestry or its officers
                or employees be liable for any damages arising in any way out of
                the use of the website or use of the information contained in
                the databases herein, including, but not limited to this
                website’s products.
              </p>
            </v-col>
          </v-row>
        </v-container>
        <v-toolbar class="grey lighten-3 d-flex justify-end">
          <v-btn
            color="primary"
            @click="
              remember = true;
              closeDialog();
            "
          >
            Accept - Never Show Again
          </v-btn>
        </v-toolbar>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
    },
  },
  data() {
    return {
      dialog: true,
      remember: false,
    };
  },
  methods: {
    closeDialog() {
      if (this.remember) {
        window.localStorage.setItem("DisclaimerDialog", true);
      }
      this.$emit("close");
    },
  },
};
</script>
